export const FETCH_VISITOR_TYPES_REQUEST = 'FETCH_VISITOR_TYPES_REQUEST';
export const FETCH_VISITOR_TYPES_SUCCESS = 'FETCH_VISITOR_TYPES_SUCCESS';
export const FETCH_VISITOR_TYPES_FAILURE = 'FETCH_VISITOR_TYPES_FAILURE';


export const ADD_VISITOR_TYPES_REQUEST = 'ADD_VISITOR_TYPES_REQUEST';
export const ADD_VISITOR_TYPES_SUCCESS = 'ADD_VISITOR_TYPES_SUCCESS';
export const ADD_VISITOR_TYPES_FAILURE = 'ADD_VISITOR_TYPES_FAILURE';



export const UPDATE_VISITOR_TYPES_REQUEST = 'UPDATE_VISITOR_TYPES_REQUEST';
export const UPDATE_VISITOR_TYPES_SUCCESS = 'UPDATE_VISITOR_TYPES_SUCCESS';
export const UPDATE_VISITOR_TYPES_FAILURE = 'UPDATE_VISITOR_TYPES_FAILURE';




export const DELETE_VISITOR_TYPES_REQUEST = 'DELETE_VISITOR_TYPES_REQUEST';
export const DELETE_VISITOR_TYPES_SUCCESS = 'DELETE_VISITOR_TYPES_SUCCESS';
export const DELETE_VISITOR_TYPES_FAILURE = 'DELETE_VISITOR_TYPES_FAILURE';



